import { useEffect } from "react";
import { FlatVsaaTag } from "../../models/VsaaTag";
import { useTagsGet } from "../../hooks/useTags";

interface TagCollectionDataLoaderProps {
  collectionId: string;
  onData: (
    collectionId: string,
    data: FlatVsaaTag[] | undefined,
    isLoading: boolean
  ) => void;
}

export function TagCollectionDataLoader({
  collectionId,
  onData,
}: TagCollectionDataLoaderProps) {
  const { data, isLoading } = useTagsGet(collectionId);

  useEffect(() => {
    onData(collectionId, data, isLoading);
  }, [collectionId, data, isLoading, onData]);

  return null;
}
